import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import superAdminApiClient from '../../../api/superAdminApiClient';

const CreateLeadModal = ({ show, handleClose, refreshLeads }) => {
    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        email: '',
        city: '',
        category: 'holidays',
        message: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        try {
            await superAdminApiClient.post('/superadmin/leads', formData);
            setLoading(false);
            handleClose();
            refreshLeads();
            setFormData({ name: '', mobile: '', email: '', city: '', category: 'holidays', message: '' }); // reset
        } catch (err) {
            console.error("Error creating lead:", err);
            setError(err.response?.data?.message || "Failed to create lead.");
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>Create New Lead</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error && <div className="alert alert-danger">{error}</div>}
                    <Form.Group className="mb-3">
                        <Form.Label>Name <span className="text-danger">*</span></Form.Label>
                        <Form.Control type="text" name="name" value={formData.name} onChange={handleChange} required placeholder="Enter Name" />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Mobile No. <span className="text-danger">*</span></Form.Label>
                        <Form.Control type="text" name="mobile" value={formData.mobile} onChange={handleChange} required placeholder="Enter Mobile No." />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Email <span className="text-danger">*</span></Form.Label>
                        <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="Enter Email" />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>City Name <span className="text-danger">*</span></Form.Label>
                        <Form.Control type="text" name="city" value={formData.city} onChange={handleChange} required placeholder="Enter City" />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Category <span className="text-danger">*</span></Form.Label>
                        <Form.Select name="category" value={formData.category} onChange={handleChange} required>
                            <option value="holidays">Holidays</option>
                            <option value="hotels">Hotels</option>
                            <option value="cab">Cab</option>
                            <option value="tirth_yatra">Tirth Yatra</option>
                            <option value="medical_tourism">Medical Tourism</option>
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Message (Optional)</Form.Label>
                        <Form.Control 
                            as="textarea" 
                            rows={3} 
                            name="message" 
                            value={formData.message} 
                            onChange={handleChange} 
                            placeholder="Enter any additional details" 
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose} disabled={loading}>Close</Button>
                    <Button variant="primary" type="submit" disabled={loading}>
                        {loading ? 'Submitting...' : 'Create Lead'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default CreateLeadModal;
